import React, { memo } from 'react'
import { Grid, CircularProgress } from '@mui/material'
import { ProgressProps } from './Progress.types'

function Progress({ size = '1rem', color = 'secondary' }: ProgressProps) {
    return (
        <Grid
            container
            alignItems="center"
            alignContent="center"
            justifyContent="center"
        >
            <Grid item xs="auto">
                <CircularProgress size={size} color={color} />
            </Grid>
        </Grid>
    )
}

export default memo(Progress)
